/** Shared presence labels/colors for DMs and sidebar */

export const PRESENCE_OPTIONS = [
  { value: "active", label: "Active", shortLabel: "Active", dot: "bg-emerald-500" },
  { value: "away", label: "Away", shortLabel: "Away", dot: "bg-amber-400" },
  { value: "busy", label: "Busy", shortLabel: "Busy", dot: "bg-orange-500" },
  {
    value: "dnd",
    label: "Do not disturb",
    shortLabel: "DND",
    dot: "bg-rose-500",
  },
];

export const OFFLINE_PRESENCE = {
  value: "offline",
  label: "Offline",
  shortLabel: "Offline",
  dot: "bg-zinc-400",
};

/** Circatron / webhook bots — static label, not online/offline. */
export const BOT_PRESENCE = {
  value: "bot",
  label: "Bot",
  shortLabel: "Bot",
  dot: "bg-sky-500",
};

export function getPresenceOption(status) {
  if (!status || status === "offline") return OFFLINE_PRESENCE;
  return (
    PRESENCE_OPTIONS.find((o) => o.value === status) || OFFLINE_PRESENCE
  );
}

/** Own status preference (always one of active/away/busy/dnd). */
export function getOwnPresenceOption(status) {
  return (
    PRESENCE_OPTIONS.find((o) => o.value === status) || PRESENCE_OPTIONS[0]
  );
}

/**
 * Resolve display presence from peer snapshot + optional live map.
 * Offline users never show Active.
 */
export function resolvePresence(peer, liveByUserId) {
  if (!peer?.user_id) return OFFLINE_PRESENCE;
  if (peer.is_bot || peer.user_id === "webhook") return BOT_PRESENCE;
  const live = liveByUserId?.get?.(peer.user_id) || liveByUserId?.[peer.user_id];
  const online =
    live?.online != null ? !!live.online : peer.online === true;
  if (!online) return OFFLINE_PRESENCE;
  const status = live?.presence_status || peer.presence_status || "active";
  return getPresenceOption(status);
}

const DESKTOP_PREF_KEY = "dm-desktop-notifications";

/** 'granted' | 'denied' | 'unset' preference (separate from Notification.permission) */
export function getDesktopNotifPref() {
  try {
    return localStorage.getItem(DESKTOP_PREF_KEY) || "unset";
  } catch {
    return "unset";
  }
}

export function setDesktopNotifPref(value) {
  try {
    localStorage.setItem(DESKTOP_PREF_KEY, value);
  } catch {
    /* ignore */
  }
}

/** True when user opted in and browser permission is granted. */
export function isDesktopNotificationsEnabled() {
  if (typeof Notification === "undefined") return false;
  if (Notification.permission !== "granted") return false;
  return getDesktopNotifPref() === "granted";
}
